import { createFileRoute } from '@tanstack/react-router'
import { DocumentEditorPage } from '@/features/editor/editor'

export const Route = createFileRoute('/_layout/_app/editor/$id')({
  component: EditorRoute,
  staticData: { title: 'Urejevalnik predloge' },
})

function EditorRoute() {
  const { id } = Route.useParams()
  return <DocumentEditorPage templateId={id} />
}
